export default __webpack_public_path__ + "static/IrxpCu6-gaming-pc-wallpaper-5663cd5ea14140873bcab73a860f504c.jpg";